import React from 'react';

export function WorkspaceFilters<T extends string>({ label, tabs, selected, count, onSelect }: {
  label: string; tabs: readonly T[]; selected: T; count: (tab: T) => number; onSelect: (tab: T) => void;
}) {
  return <div role="group" aria-label={label} className="flex flex-wrap gap-2">
    {tabs.map(tab => <button key={tab} type="button" aria-pressed={selected === tab} onClick={() => onSelect(tab)}
      className={`min-h-11 rounded-xl border px-3 py-2 text-xs font-semibold focus-visible:ring-2 focus-visible:ring-brand-neonBlue ${selected === tab ? 'border-brand-neonBlue/40 bg-brand-neonBlue/10 text-brand-neonBlue' : 'border-white/10 text-slate-400 hover:text-white'}`}>
      {tab} <span className="ml-1 tabular-nums">({count(tab)})</span>
    </button>)}
  </div>;
}
